
import React from "react";

const Footer = () => {
    return (
        <footer className="footer-admin mt-auto">
            <div className="container-xl px-4">
                <div className="row">
                    <div className="col-md-12 small text-md-end">Copyright © 2023 indigalleria</div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;